import React from "react";
import { Table, TableBody, TableContainer } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TableHeader, TablePagination } from "../../../components/table";
import { logsTableHead } from "../../../app/config/tables/logsTableHead";
import LogsTableRow from "../../../components/table/rows/logsTableRow";

function ComplainLogsList({ data, filter, onRequestSort, onPreviousPage, onNextPage, onDetails, hasPrevious, hasNext }) {
    const { t } = useTranslation('LogsScreen');

    return (
        <div className={`fk-company-complains-list${onDetails ? ' --on-details' : ''}`}>
            <div className="fk-filter-container">
                <h3>History of events related to the case</h3>
            </div>
            <TableContainer>
                <Table size="medium" className="fk-table">
                    <TableHeader
                        items={logsTableHead}
                        orderBy={filter.orderBy}
                        order={filter.orderDirection}
                        onRequestSort={onRequestSort}
                        rowCount={data.length}
                        screen="LogsScreen"
                    />
                    <TableBody>
                    {data.map((log) => (
                            <LogsTableRow
                                key={log.id}
                                log={log}
                            />
                        )
                    )}
                    </TableBody>
                </Table>
                {(!data || data.length === 0) &&
                    <p className="fk-no-items">
                        {t('noLogRecords')}
                    </p>
                }
            </TableContainer>
            <TablePagination
                filter={filter}
                hasPrevious={hasPrevious}
                hasNext={hasNext}
                handlePreviousPage={onPreviousPage}
                handleNextPage={onNextPage}
            />
        </div>
    );
}

export default ComplainLogsList;
